export * from './tiposConsultasAntecedentesTypes';

export { default as ConsultaDinamicaTypes } from './consultaDinamicaTypes';
